module.exports = __webpack_public_path__ + "img/2.ca5c2f86.png";